module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/why-using-vux-loader-148.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/why-using-vux-loader.md
// module id = 758
// module chunks = 175